import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
import showDiv from '@ivy/fts/showDiv';
import { env } from '@ivy/fts/envInfo/envInfo';
import { addStatistics } from '../require';
import CouponListPopup from '@/components/couponListPopup.vue';
let GetCoupon = class GetCoupon extends Vue {
    constructor() {
        super(...arguments);
        this.vipCouponList = [];
    }
    get isShow() {
        return ((this.coupons && this.coupons.length) ||
            (this.vipCouponList && this.vipCouponList.length));
    }
    get couponsFilter() {
        return this.coupons.filter((item, index) => index < 3);
    }
    get vipCouponListFilter() {
        return this.vipCouponList.filter((item, index) => index < 3);
    }
    async created() {
        await env.init();
        let { data } = await this.$axios.get(`/api/goods/shop/search/coupon/getProcessingCouponByGoods`, {
            params: {
                spuId: +this.$route.query.spuId || 0,
                offset: 0,
                limit: 20,
                isVip: '1',
            },
        });
        this.vipCouponList = data;
    }
    async showCurrentCoupons() {
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            this.$emit('show-shadow', true);
            return await env.login();
        }
        let { spuId } = this.$route.query;
        await showDiv(CouponListPopup, {
            visible: true,
            mode: 'acquire',
            goodsStatus: this.goodsStatus,
            product: {
                spuId: spuId,
            },
            showVip: true,
        });
        // 埋点 点击商详页优惠券
        addStatistics({
            event: 'Click_GoodDetails_Coupons_H5',
            p1: this.point,
            p2: this.goodsStatus,
        });
    }
};
tslib_1.__decorate([
    Prop()
], GetCoupon.prototype, "coupons", void 0);
tslib_1.__decorate([
    Prop()
], GetCoupon.prototype, "point", void 0);
tslib_1.__decorate([
    Prop()
], GetCoupon.prototype, "goodsStatus", void 0);
GetCoupon = tslib_1.__decorate([
    Component({
        filters: {
            toInteger: num => {
                return +num.toFixed();
            },
        },
    })
], GetCoupon);
export default GetCoupon;
